import React from 'react';
import PropTypes from 'prop-types';
import { scrollToTop } from '../../utils/smartutils';

const TextAreaField = ({
  input,
  placeholder,
  minLength,
  maxLength,
  disabled,
  pattern,
  min,
  max,
  meta: { touched, error },
  style,
  required,
}) => {
  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <textarea
        {...input}
        placeholder={placeholder}
        maxLength={maxLength}
        minLength={minLength}
        disabled={disabled}
        pattern={pattern}
        min={min}
        max={max}
        style={style}
        required={required}
        spellCheck
        lang="pt-BR"
      />
      {touched && error && (
        <span className="form__form-group-error">
          {error} {scrollToTop()}
        </span>
      )}
    </div>
  );
};

TextAreaField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  minLength: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  pattern: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  required: PropTypes.bool,
};

TextAreaField.defaultProps = {
  placeholder: '',
  disabled: false,
  minLength: '',
  maxLength: '9999999',
  pattern: null,
  min: null,
  max: null,
  style: null,
  required: false,
  meta: {
    touched: false,
    error: '',
  },
};

export default TextAreaField;
